import React, { useState } from "react";
import "./Profile.css";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

import { API_URL } from "../../utils/config";
import { useAuth } from "../../contexts/AuthProvider";
const baseUrl = API_URL;

const Password = () => {
  const { t, i18n } = useTranslation("profile");
  const lang = i18n.language;

  /* ------------------------- state ------------------------- */
  const [currPassword, setCurrPassword] = useState("");
  const [currentVisible, setCurrentVisible] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [newVisible, setNewVisible] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmVisible, setConfirmVisible] = useState(false);

  const [Errors, setErrors] = useState(null);
  const navigate = useNavigate();

  const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };

  const { isAuthenticated } = useAuth();
  /* ---------------------- helpers -------------------------- */
  const checkStrength = (pwd) => {
    let score = -1;
    if (pwd.length >= 8) score++; // length
    if (/[A-Z]/.test(pwd)) score++; // uppercase
    if (/[a-z]/.test(pwd)) score++; // lowercase
    if (/[0-9]/.test(pwd)) score++; // number
    if (/[\W_]/.test(pwd)) score++; // special
    const colors = ["#DC3545", "#DC3545", "#FFC107", "#FFC107", "#198754"];
    return colors[score] || "#DC3545";
  };

  const isValid = () =>
    currPassword !== "" &&
    currPassword !== newPassword &&
    newPassword.length >= 8 &&
    newPassword === confirmPassword &&
    checkStrength(newPassword) === "#198754";

  /* ----------------------- SVGs ---------------------------- */
  const EyeOpen = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 16.33C9.61 16.33 7.67 14.39 7.67 12C7.67 9.61 9.61 7.67 12 7.67C14.39 7.67 16.33 9.61 16.33 12C16.33 14.39 14.39 16.33 12 16.33ZM12 9.17C10.44 9.17 9.17 10.44 9.17 12C9.17 13.56 10.44 14.83 12 14.83C13.56 14.83 14.83 13.56 14.83 12C14.83 10.44 13.56 9.17 12 9.17Z"
        fill="#4D4D4D"
      />
      <path
        d="M12 21.02C8.24 21.02 4.69 18.82 2.25 15C1.19 13.35 1.19 10.66 2.25 9C4.7 5.18 8.25 2.98 12 2.98C15.75 2.98 19.3 5.18 21.74 9C22.8 10.65 22.8 13.34 21.74 15C19.3 18.82 15.75 21.02 12 21.02ZM12 4.48C8.77 4.48 5.68 6.42 3.52 9.81C2.77 10.98 2.77 13.02 3.52 14.19C5.68 17.58 8.77 19.52 12 19.52C15.23 19.52 18.32 17.58 20.48 14.19C21.23 13.02 21.23 10.98 20.48 9.81C18.32 6.42 15.23 4.48 12 4.48Z"
        fill="#4D4D4D"
      />
    </svg>
  );

  const EyeClosed = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.47 15.28C9.28 15.28 9.09 15.21 8.94 15.06C8.12 14.24 7.67 13.15 7.67 12C7.67 9.61 9.61 7.67 12 7.67C13.15 7.67 14.24 8.12 15.06 8.94C15.2 9.08 15.28 9.27 15.28 9.47C15.28 9.67 15.2 9.86 15.06 10L10 15.06C9.85 15.21 9.66 15.28 9.47 15.28ZM12 9.17C10.44 9.17 9.17 10.44 9.17 12C9.17 12.5 9.3 12.98 9.54 13.4L13.4 9.54C12.98 9.3 12.5 9.17 12 9.17Z"
        fill="#464646"
      />
      <path
        d="M5.6 18.51C5.43 18.51 5.25 18.45 5.11 18.33C4.04 17.42 3.08 16.3 2.26 15C1.2 13.35 1.2 10.65 2.26 9C4.7 5.18 8.25 2.98 12 2.98C14.2 2.98 16.37 3.74 18.27 5.17C18.6 5.42 18.67 5.89 18.42 6.22C18.17 6.55 17.7 6.62 17.37 6.37C15.73 5.13 13.87 4.48 12 4.48C8.77 4.48 5.68 6.42 3.52 9.81C2.77 10.98 2.77 13.02 3.52 14.19C4.27 15.36 5.13 16.37 6.08 17.19C6.39 17.46 6.43 17.93 6.16 18.25C6.02 18.42 5.81 18.51 5.6 18.51Z"
        fill="#464646"
      />
      <path
        d="M12 21.02C10.67 21.02 9.37 20.75 8.12 20.22C7.74 20.06 7.56 19.62 7.72 19.24C7.88 18.86 8.32 18.68 8.7 18.84C9.76 19.29 10.87 19.52 12 19.52C15.23 19.52 18.32 17.58 20.48 14.19C21.23 13.02 21.23 10.98 20.48 9.81C20.16 9.32 19.82 8.85 19.46 8.41C19.2 8.09 19.25 7.62 19.57 7.35C19.89 7.09 20.36 7.13 20.63 7.46C21.02 7.94 21.4 8.46 21.74 9C22.8 10.65 22.8 13.35 21.74 15C19.3 18.82 15.75 21.02 12 21.02Z"
        fill="#464646"
      />
      <path
        d="M12.69 16.27C12.34 16.27 12.02 16.02 11.95 15.66C11.87 15.25 12.14 14.86 12.55 14.79C13.65 14.59 14.57 13.67 14.77 12.57C14.85 12.16 15.24 11.9 15.65 11.97C16.06 12.05 16.33 12.44 16.25 12.85C15.93 14.58 14.55 15.95 12.83 16.27C12.78 16.26 12.74 16.27 12.69 16.27Z"
        fill="#464646"
      />
      <path
        d="M2 22.75C1.81 22.75 1.62 22.68 1.47 22.53C1.18 22.24 1.18 21.76 1.47 21.47L8.94 14C9.23 13.71 9.71 13.71 10 14C10.29 14.29 10.29 14.77 10 15.06L2.53 22.53C2.38 22.68 2.19 22.75 2 22.75Z"
        fill="#464646"
      />
      <path
        d="M14.53 10.22C14.34 10.22 14.15 10.15 14 10C13.71 9.71 13.71 9.23 14 8.94L21.47 1.47C21.76 1.18 22.24 1.18 22.53 1.47C22.82 1.76 22.82 2.24 22.53 2.53L15.06 10C14.91 10.15 14.72 10.22 14.53 10.22Z"
        fill="#464646"
      />
    </svg>
  );

  /* --------------------- submit ---------------------------- */
  const Save = async () => {
    const loadingToast = toast.loading(t("password.toast.processing"));

    /* client-side validations */
    if (currPassword === newPassword) {
      toast.update(loadingToast, {
        render: t("password.toast.errorSame"),
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    } else if (newPassword !== confirmPassword) {
      toast.update(loadingToast, {
        render: t("password.toast.errorMismatch"),
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    } else if (newPassword.length < 8) {
      toast.update(loadingToast, {
        render: t("password.toast.errorShort"),
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    } else if (checkStrength(newPassword) !== "#198754") {
      toast.update(loadingToast, {
        render: t("password.toast.errorWeak"),
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    }

    if (!isValid()) return;

    try {
      if (!isAuthenticated) throw new Error(t("password.toast.authNoToken"));

      const res = await fetch(
        `${baseUrl}/api/v1/attnd-supplier/auth/change-password`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            lang: getLangFromLocalStorage(),

          },
          body: JSON.stringify({
            currentPassword: currPassword,
            newPassword: newPassword,
            passwordConfirm: confirmPassword,
          }),
        }
      );

      if (!res.ok) {
        if (res.status === 401) {
          navigate("/login");
          throw new Error(t("password.toast.authUnauthorized"));
        }
        const err = await res.json();
        setErrors(err);
        const msg =
          err.error ||
          err.errors?.[0]?.currentPassword ||
          err.errors?.[0]?.newPassword ||
          err.errors?.[0]?.passwordConfirm ||
          t("password.toast.unknown");
        throw new Error(msg);
      }

      toast.update(loadingToast, {
        render: t("password.toast.success"),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      setCurrPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setCurrentVisible(false);
      setNewVisible(false);
      setConfirmVisible(false);
    } catch (error) {
      toast.update(loadingToast, {
        render: `Error: ${error.message}`,
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  /* ---------------------- constants ------------------------ */
  const diffClass =
    "flex flex-row items-center p-0 gap-8 w-[732px] h-[6px]";
  const buttonClass =
    "box-border w-[354px] h-[48px] rounded-sm flex items-center justify-center font-inter font-normal font-bold text-base leading-[22px] text-center cursor-pointer";

  /* ----------------------- render -------------------------- */
  return (
    <div className="pt-[69px] px-6 pb-0 flex flex-col gap-10">
      {/* ===== Current Password ===== */}
      <div className="box-border flex flex-col gap-4 w-[732px]">
        <div className="flex flex-col gap-2">
          <p className="h-[22px] font-inter font-semibold text-[#292929] m-0">
            {t("password.labels.currentPassword")}
          </p>
          <div
            className="relative w-[732px] h-[48px] px-4 bg-white border border-[#6609F8] rounded-sm"
            style={
              Errors?.errors?.[0]?.currentPassword
                ? { border: "1px solid red" }
                : {}
            }
          >
            <input
              className="outline-none w-full h-full border-none"
              type={currentVisible ? "text" : "password"}
              value={currPassword}
              onChange={(e) => setCurrPassword(e.target.value)}
            />
            <span
              className={`absolute ${lang === "ar" ? "left-[15px]" : "right-[15px]"} top-[10px]`}
              onClick={() => setCurrentVisible((v) => !v)}
            >
              {currentVisible ? <EyeOpen /> : <EyeClosed />}
            </span>
          </div>
          <div className={diffClass}>
            {[2, 4, 6, 8].map((l, i) => (
              <svg key={i} width="159" height="6">
                <rect
                  width="159"
                  height="6"
                  rx="3"
                  fill={currPassword.length >= l ? "#DC3545" : "#DBDBDB"}
                />
              </svg>
            ))}
          </div>
        </div>

        {/* ===== New Password ===== */}
        <div className="flex flex-col gap-2">
          <p className="h-[22px] font-inter font-semibold text-[#292929] m-0">
            {t("password.labels.newPassword")}
          </p>
          <div
            className="relative w-[732px] h-[48px] px-4 bg-white border border-[#6609F8] rounded-sm"
            style={
              Errors?.errors?.[0]?.newPassword
                ? { border: "1px solid red" }
                : {}
            }
          >
            <input
              className="outline-none w-full h-full border-none"
              type={newVisible ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <span
              className={`absolute ${lang === "ar" ? "left-[15px]" : "right-[15px]"} top-[10px]`}
              onClick={() => setNewVisible((v) => !v)}
            >
              {newVisible ? <EyeOpen /> : <EyeClosed />}
            </span>
          </div>
          <div className={diffClass}>
            {[2, 4, 6, 8].map((l, i) => (
              <svg key={i} width="159" height="6">
                <rect
                  width="159"
                  height="6"
                  rx="3"
                  fill={
                    newPassword.length >= l
                      ? checkStrength(newPassword)
                      : "#DBDBDB"
                  }
                />
              </svg>
            ))}
          </div>
        </div>

        {/* ===== Confirm Password ===== */}
        <div className="flex flex-col gap-2">
          <p className="h-[22px] font-inter font-semibold text-[#292929] m-0">
            {t("password.labels.confirmPassword")}
          </p>
          <div
            className="relative w-[732px] h-[48px] px-4 bg-white border border-[#6609F8] rounded-sm"
            style={
              Errors?.errors?.[0]?.passwordConfirm
                ? { border: "1px solid red" }
                : {}
            }
          >
            <input
              className="outline-none w-full h-full border-none"
              type={confirmVisible ? "text" : "password"}
              value={confirmPassword}
              onPaste={(e) => e.preventDefault()}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <span
              className={`absolute ${lang === "ar" ? "left-[15px]" : "right-[15px]"} top-[10px]`}
              onClick={() => setConfirmVisible((v) => !v)}
            >
              {confirmVisible ? <EyeOpen /> : <EyeClosed />}
            </span>
          </div>
          <div className={diffClass}>
            {[2, 4, 6, 8].map((l, i) => (
              <svg key={i} width="159" height="6">
                <rect
                  width="159"
                  height="6"
                  rx="3"
                  fill={
                    confirmPassword.length >= l
                      ? checkStrength(confirmPassword)
                      : "#DBDBDB"
                  }
                />
              </svg>
            ))}
          </div>
        </div>
      </div>

      {/* ===== Buttons ===== */}
      <div className="flex justify-between w-[732px] h-[48px]">
        <button
          onClick={() => navigate(-1)}
          className={`${buttonClass} bg-white border border-[#6609F8] text-[#6609F8]`}
        >
          {t("password.buttons.cancel")}
        </button>
        <button
          onClick={Save}
          style={isValid() ? {} : { background: "#888888" }}
          className={`${buttonClass} text-white bg-[#6609F8] border-none`}
        >
          {t("password.buttons.save")}
        </button>
      </div>

      <ToastContainer />
    </div>
  );
};

export default Password;
